<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <span>{{ total }} Dénonciation</span>
        </h1>
      </template>
      <a
        slot="dropdown-content"
        class="dropdown-item"
        @click="loadDocuments">
        <span class="icon is-medium"><i class="fas fa-sync" /></span><span>Actualiser données</span>
      </a>
    </page-nav-bar>
    <page-content
      :has-sticky-col-left="true"
      :has-left-col-collapse="true"
      :opened-col="openedCol"
      :has-padd-right-normal="true">
      <template slot="left-col-small">
        <col-collapse-filter
          :has-filter="hasFilter"
          :loading="loading"
          @opened="openedCol = !openedCol"
          @resetFilters="resetFilters()">
          <div class="is-padding">
            <div class="field">
              <div class="control">
                <multiselect
                  v-model="filters.contact"
                  label="name"
                  track-by="pk"
                  :options="contacts"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  @select="updateSimpleFilter"
                  :custom-label="val => limitText(`${val.last_name} ${val.first_name}`)"
                  @remove="updateFilter([], 'contact')"
                  :placeholder="''"
                  @search-change="getContacts">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="contacts.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucun contact trouvée.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="singleLabel"
                    class="multiselect__placeholder">Contact</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Contact</span>
                </multiselect>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <!-- <multiselect
                  v-model="filters.program"
                  label="name"
                  track-by="pk"
                  :options="programs"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  @select="updateSimpleFilter"
                  :placeholder="''"
                  @remove="updateFilter([], 'program')"
                  @search-change="getPrograms"> -->
                <multiselect
                  @input="updateSimpleFilter"
                  @search-change="getProgramsByName"
                  @open="!programsFilter.length ? getProgramsByName() : null"
                  :loading="loadingFilters === 'program'"
                  v-model="filters.programs"
                  label="name"
                  track-by="pk"
                  class="multiselect--option-ico is-single_choice"
                  open-direction="bottom"
                  :multiple="true"
                  :options="programsFilter"
                  :searchable="true"
                  :close-on-select="false"
                  :show-labels="false"
                  :placeholder="''">
                  <span slot="noResult">Oups! Aucun programme trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="singleLabel"
                    class="multiselect__placeholder">Programme</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Programme</span>
                  <span
                    slot="selection"
                    class="multiselect__placeholder"
                    slot-scope="{ values }"
                    v-if="values.length">
                    <span>Programmes ({{ values.length }})</span>
                  </span>
                </multiselect>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <multiselect
                  v-model="filters.user"
                  label="name"
                  track-by="pk"
                  :options="users"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  @select="updateSimpleFilter"
                  :custom-label="val => limitText(`${val.last_name} ${val.first_name}`)"
                  @remove="updateFilter([], 'user')"
                  :placeholder="''"
                  @search-change="getUsers"
                  @open="getUsers">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="users.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucun vendeur trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="singleLabel"
                    class="multiselect__placeholder">Vendeur</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Vendeur</span>
                </multiselect>
              </div>
            </div>
            <div
              v-if="isPromoteur"
              class="field">
              <div class="control">
                <multiselect
                  v-model="filters.account"
                  label="name"
                  track-by="pk"
                  :options="accounts"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  @select="updateSimpleFilter"
                  :placeholder="''"
                  @remove="updateFilter([], 'account')"
                  @search-change="getAccounts">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="accounts.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucun société trouvée.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="singleLabel"
                    class="multiselect__placeholder">Société</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Société</span>
                </multiselect>
              </div>
            </div>
            <div
              v-if="!isPromoteur"
              class="field">
              <div class="control">
                <multiselect
                  v-model="filters.promoteur"
                  label="name"
                  track-by="pk"
                  :options="promoteurs"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  @select="updateSimpleFilter"
                  :placeholder="''"
                  @remove="updateFilter([], 'promoteur')"
                  @search-change="getPromoteurs">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="promoteurs.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucun promoteur trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="singleLabel"
                    class="multiselect__placeholder">Promoteur</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Promoteur</span>
                </multiselect>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <date-picker
                  :model="{created_on__gte: filters.created_on__gte, created_on__lte: filters.created_on__lte}"
                  :style-version="2"
                  :is-range="true"
                  :name="'date'"
                  :placeholder="'Date de création'"
                  :config="{mode: 'range'}"
                  @input="Object.assign(filters, $event); updateSimpleFilter()" />
              </div>
            </div>
            <div class="field">
              <div class="control">
                <input
                  @input="updateSimpleFilter"
                  v-model="filters.contact__searchable_name"
                  class="input"
                  type="text"
                  placeholder="Prénom / Nom">
              </div>
            </div>
            <div class="field">
              <div class="control">
                <input
                  @input="updateSimpleFilter"
                  v-model="filters.contact__email"
                  class="input"
                  type="text"
                  placeholder="Email">
              </div>
            </div>
            <div class="field">
              <div class="control">
                <input
                  @input="updateSimpleFilter"
                  v-model="filters.address__city"
                  class="input"
                  type="text"
                  placeholder="Ville">
              </div>
            </div>
            <div class="field">
              <div class="control">
                <input
                  @input="updateSimpleFilter"
                  v-model="filters.address__zip_code"
                  class="input"
                  type="text"
                  placeholder="Zip code">
              </div>
            </div>
          </div>
        </col-collapse-filter>
      </template>
      <div>
        <list-top-bar
          :counted="count"
          label="denonciation(s)"
          :has-filtered="hasFilter"
          :display-export="true"
          :not-export-all="true"
          :child-action-group="parentActionGroup"
          @update:childActionGroup="handleActionGroupUpdate">
        </list-top-bar>
        <div class="is-flex is-space-between is-border-left is-border-right is-border-bottom has-background-white">
          <div
            class="field is-grouped is-padding-small"
            style="margin-bottom: 0">
            <p
              v-for="status in activationStatus"
              :key="status.value"
              class="control">
              <label
                class="checkbox checkRadioIsHide"
                :for="status.value">
                <input
                  :id="status.value"
                  v-model="filters.status"
                  :name="status.name"
                  type="checkbox"
                  :value="status.value"
                  @click="updateSimpleFilter">
                <span
                  class="tag"
                  :class="status.color">
                  <span>{{ status.label }}</span>
                  <span class="icon"><i
                    class="far"
                    :class="filters.status.includes(status.value) ? 'fa-check-square' : 'fa-square'" /></span>
                </span>
              </label>
            </p>
          </div>
          <div
            class="column is-narrow is-paddingless is-border-left container-btn-export-denon"
            v-if="multiselection && parentActionGroup">
            <a
              @click="selectedItems.length ? (exportXlsFromMultiselect(service, 'list-dénonciations'), cancelSelect()) : ''"
              :style="selectedItems.length ? 'background-color: #8dbb7d; color: white; cursor: pointer' : 'cursor: default; color: #D7D7D7'"
              class="btn_export_denon is-uppercase">
              <span class="icon"><i class="fas fa-file-excel"></i></span><span>Exporter Dénonciations</span>
            </a>
          </div>
        </div>
        <filters-tags
          id="option-tag"
          :has-filter="hasFilter"
          :filters="filters"
          :ignore-tags="['status']"
          @reset="resetFilters"
          @update="updateFromTag($event)" />
        <spinner-round
          v-if="loading"
          :is-loading="loading" />
        <table-controls-vue
          v-if="!loading && items.length"
          :has-sticky="true"
          :no-scroll-direction="true">
          <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-large is-last-fixed-small has-actionsontd">
            <thead class="has-cells-vcentered">
              <tr class="is-size-6">
                <th
                  class="is-paddingless has-text-centered"
                  style="z-index:2;">
                  <columns-toggles
                    :entries="columnsList"
                    :source="columns"
                    @update="updateColumns" />
                </th>
                <th>
                  <sortable
                    sort-id="program__name"
                    :sort="sortBy.program__name"
                    label="Programme"
                    @sort="sort('program__name', $event)" />
                </th>
                <th v-if="!isPromoteur && showColumn('promoteur')">
                  <sortable
                    sort-id="promoteur"
                    :sort="sortBy.promoteur"
                    label="Promoteur"
                    @sort="sort('promoteur', $event)" />
                </th>
                <th v-if="isPromoteur && showColumn('account')">
                  <sortable
                    sort-id="account"
                    :sort="sortBy.account"
                    label="Société"
                    @sort="sort('account', $event)" />
                </th>
                <th v-if="showColumn('user') && (isAdmin || isManager)">
                  <sortable
                    sort-id="user"
                    :sort="sortBy.user"
                    label="Vendeur"
                    @sort="sort('user', $event)" />
                </th>
                <th v-if="showColumn('contact')">
                  <sortable
                    sort-id="contact"
                    :sort="sortBy.contact"
                    label="Contact"
                    @sort="sort('contact', $event)" />
                </th>
                <th v-if="showColumn('contact_phone')">
                  <span>Téléphone Contact</span>
                </th>
                <th v-if="showColumn('contact_address')">
                  <span>Ville Contact</span>
                </th>
                <th v-if="showColumn('contact_email')">
                  <span>Email Contact</span>
                </th>
                <th v-if="showColumn('created_on')">
                  <sortable
                    sort-id="created_on"
                    :sort="sortBy.created_on"
                    label="Date de création"
                    @sort="sort('created_on', $event)" />
                </th>
                <th v-if="(isAdmin && isPromoteur)">
                  <span>Doublon dénonciation</span>
                </th>
                <th v-if="(isAdmin && isPromoteur)">
                  <span>Doublon contact</span>
                </th>
                <th class="has-text-centered" />
              </tr>
            </thead>
            <tbody class="has-cells-vcentered">
              <tr>
                <td
                  v-if="multiselection"
                  colspan="12"
                  style="padding: 0">
                  <div
                    class="is-flex is-nowrap is-align-items-center container_select_multiple_denon">
                    <a
                      :style="!selectedItems.length > 0? 'background-color: #219CED' : 'background-color: #8CBB7D'"
                      class="select_multiple_denon"
                      @click="$store.commit('selectAllMultiselectionItems')">
                      <i
                        style="font-size: 17px; padding: 0px 32px 0px 26px"
                        class="far fa-check-double"></i>
                      <span class="is-padding-left-xxsmall">{{ !selectedItems.length > 0 ? 'Cliquez ici pour sélectionner toutes les lignes de la page' : 'Déselectionnez toutes les lignes de la page' }}</span>
                    </a>
                  </div>
                </td>
              </tr>
              <tr
                v-for="(denunciation) in items"
                :id="'e' + denunciation.pk"
                :key="denunciation.pk"
                class="is-size-6">
                <td class="is-marginless has-text-centered">
                  <multiselect-button
                    v-if="multiselection"
                    :data="denunciation" />
                  <span
                    v-else
                    :data-tooltip="optionStatus[denunciation.status].label"
                    class="dot tooltip is-tooltip-right"
                    :class="denunciation.status | dotClass" />
                  <!-- <a
                    v-if="isAdmin && isPromoteur && denunciation.duplicate_risk"
                    class="tag is-small is-tooltip-right tooltip is-margin-left-xsmall"
                    :class="colors[denunciation.duplicate_risk - 1]"
                    :data-tooltip="messages[denunciation.duplicate_risk - 1]"
                    @click="showDuplicates(denunciation, denunciation.contact)">
                    <i class="fal fa-exclamation-triangle" />
                  </a> -->
                </td>
                <td class="is-cell-hoverable">
                  <router-link
                    :to="{name: 'ProgramVue', params: {id: denunciation.program.pk}}"
                    class="fullLink">
                    {{ denunciation.program.name }}
                  </router-link>
                </td>
                <!--  && !isPromoteurDetailsActivated(denunciation) -->
                <!-- <td
                  v-if="!isPromoteur && showColumn('promoteur')"
                  class="is-cell-hoverable is-narrow">
                  <router-link
                    :to="{name: 'PromoteurPresentation', params: {id: denunciation.promoteur.pk}}">
                    <span class="">{{ denunciation.promoteur.name }}</span>
                  </router-link>
                </td> -->
                <!-- && !isPromoteurDetailsActivated(denunciation) -->
                <td v-if="!isPromoteur && showColumn('promoteur')">
                  {{ denunciation.promoteur.name }}
                </td>
                <td v-if="isPromoteur && showColumn('account')">
                  {{ denunciation.user.account.name }}
                </td>
                <td
                  v-if="showColumn('user') && (isAdmin || isManager)"
                  class="is-cell-hoverable">
                  <router-link
                    :to="{name: 'UserVue', params: {id: denunciation.user.pk}}"
                    class="fullLink">
                    {{ denunciation.user.last_name }} {{ denunciation.user.first_name }}
                  </router-link>
                </td>
                <td
                  v-if="showColumn('contact')"
                  :class="{'is-cell-hoverable' : denunciation.contact.account.pk === currentUser.account.pk}">
                  <router-link
                    v-if="denunciation.contact.account.pk === currentUser.account.pk"
                    :to="{name: 'ContactVue', params: {id: denunciation.contact.pk}}"
                    class="fullLink">
                    {{ denunciation.contact.last_name }} {{ denunciation.contact.first_name }}
                  </router-link>
                  <template v-else>
                    {{ denunciation.contact.last_name }} {{ denunciation.contact.first_name }}
                  </template>
                </td>
                <td v-if="showColumn('contact_phone')">
                  <phone-number :phone="denunciation.contact.phone" />
                </td>
                <td v-if="showColumn('contact_address')">
                  <span v-if="denunciation.contact.address != null">{{ denunciation.contact.address.city }} ({{ denunciation.contact.address.zip_code }})</span>
                  <span v-else>--</span>
                </td>
                <td v-if="showColumn('contact_email')">
                  <span>{{ denunciation.contact.email }}</span>
                </td>
                <td v-if="showColumn('created_on')">
                  {{ denunciation.created_on | prettyDate }}
                </td>
                <td
                  v-if="(isAdmin && isPromoteur)"
                  class="is-cell-hoverable">
                  <a
                    v-if="isAdmin && isPromoteur && denunciation.duplicate_risk"
                    class="is-small is-tooltip-right tooltip is-margin-left-xsmall"
                    :class="colors[denunciation.duplicate_risk - 1]"
                    :data-tooltip="messages[denunciation.duplicate_risk - 1]"
                    @click="getDoublon(denunciation)">
                    <i class="fal fa-check"></i>
                  </a>
                  <span v-if="!denunciation.duplicate_risk">--</span>
                </td>
                <td
                  v-if="(isAdmin && isPromoteur)"
                  class="is-cell-hoverable">
                  <a
                    v-if="isAdmin && isPromoteur && denunciation.all_pk_contact_risk"
                    class="is-small is-tooltip-right tooltip is-margin-left-xsmall"
                    :class="colors[denunciation.all_pk_contact_risk - 1]"
                    :data-tooltip="messages[denunciation.all_pk_contact_risk - 1]"
                    @click="getDoublonContact(denunciation)">
                    <i class="fal fa-check"></i>
                  </a>
                  <span v-if="!denunciation.all_pk_contact_risk">--</span>
                </td>
                <td>
                  <display-button-list
                    :buttons="buttonList"
                    :data="denunciation"
                    :hide-text-when-solo="true" />
                </td>
              </tr>
            </tbody>
          </table>
        </table-controls-vue>
        <div v-show="!loading && !items.length">
          <div class="is-padding">
            <h2 class="title is-3 has-text-weight-bold">
              Aucune dénonciation disponible
            </h2>
            <a
              v-if="hasFilter"
              class="has-text-primary"
              @click="resetFilters"><span class="icon"><i
                class="fal fa-undo-alt" /></span> <span>Réinitialiser les filtres</span></a>
          </div>
        </div>
        <pagination
          :loading="loading"
          :current-page="currentPage"
          :total-page="totalPage"
          @changePage="loadItems($event)" />
      </div>
    </page-content>
  </div>
</template>

<script>
import { ColumnConf, DefaultValues, Filter, FilterGetter, Multiselection, GenericList, Sort } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import { cloneDeep } from 'lodash'
import UploadMixin from '../../mixins/UploadMixin'

export default {
  name: 'DenunciationList',
  filters: {
    dotClass (value) {
      const COLORS = {
        'approved': 'has-background-success',
        'pending': 'has-background-warning',
        'refused': 'has-background-danger'
      }
      return COLORS[value]
    }
  },
  mixins: [GenericList, Filter, Sort, DefaultValues, ColumnConf, FilterGetter, Multiselection, UploadMixin],
  data () {
    return {
      contacts: [],
      promoteurs: [],
      programs: [],
      users: [],
      accounts: [],
      setQueryAtStart: true,
      columnsConfResource: 'options',
      duplicate_contact: false,
      duplicate_denunciation: false,
      buttonList: [
        {
          action: (id) => {
            this.updateStatus(id, 'approved')
          },
          display: (o) => {
            return o.status === 'pending' && this.isAdmin && this.isPromoteur
          },
          icon: 'fa-check',
          text: 'Accepter',
          needProfile: ['admin']
        },
        {
          action: (id) => {
            this.updateStatus(id, 'refused')
          },
          display: (o) => {
            return o.status === 'pending' && this.isAdmin && this.isPromoteur
          },
          icon: 'fa-times',
          text: 'Refuser'
        },
        {
          action: (id) => {
            this.deleteItem(id)
          },
          display: (o) => {
            return o.status === 'approved' && this.isAdmin && this.isPromoteur
          },
          icon: 'fa-trash-alt',
          text: 'Supprimer'
        },
        {
          icon: ['fa-tasks'],
          text: 'Vérifier Doublons',
          needProfile: ['admin'],
          action: async id => {
            try {
              const { data } = await this.$api.get(this.$resources.CLAIM_CHECK(id))
              if (data.duplicates.length > 0) {
                for (const e of this.items) {
                  if (e.pk === id) {
                    // e.all_pk_contact = data.all_pk_contact
                    e.duplicate_risk = data.duplicate_risk
                    e.all_pk_contact_risk = data.all_pk_contact_risk
                    break
                  }
                }
                this.$toasted.global.danger('Doublon trouvé')
              } else {
                this.$toasted.global.success('Aucun doublon trouvé')
              }
              this.loadItems()
            } catch (e) {
              console.log(e)
            }
          },
          display: o => this.isAdmin && this.isPromoteur && o.status === 'pending'
        }
      ],
      loadDocuments: this.loadItems,
      filters: {
        contact: null,
        account: null,
        program: null,
        programs: [],
        user: null,
        created_on__gte: null,
        created_on__lte: null,
        status: ['pending'],
        pk: []
      },
      initFilters: {
        contact: null,
        account: null,
        program: null,
        programs: [],
        user: null,
        created_on__gte: null,
        created_on__lte: null,
        status: ['pending'],
        pk: []
      },
      service: 'CLAIM',
      items: [],
      openedCol: false,
      activationStatus: [
        { value: 'approved', label: 'Accepté', color: 'is-success' },
        { value: 'pending', label: 'En attente', color: 'is-warning' },
        { value: 'refused', label: 'Refusé', color: 'is-danger' }
      ],
      colors: ['is-optioned', 'is-warning', 'is-danger'],
      messages: ['Doublon Nom/Prénom', 'Doublon Nom/Prénom et Adresse', 'Doublon Email'],
      denunLoading: false,
      claimsForExport: [],
      // bigExport: false,
      parentActionGroup: false
    }
  },
  computed: {
    ...mapState(['currentUser', 'savedFilters']),
    ...mapGetters(['isAdmin', 'isManager', 'isPromoteur', 'isSeller']),
    ...mapGetters({ storeAccounts: 'accounts' }),
    /**
      * object for the columns to show in list
      * @return {Object}
      */
    columnsShow () {
      let columns = {}
      if (!this.isPromoteur) {
        columns.promoteur = { label: 'Promoteur', mobile: true }
      }
      if (this.isPromoteur) {
        columns.account = { label: 'Société', mobile: true }
      }
      if (this.isAdmin || this.isManager) {
        columns.user = { label: 'Vendeur', mobile: true }
        // columns.doublon_contact = { label: 'Doublon contact', mobile: true }
        // columns.doublon_denunciation = { label: 'Doublon dénon.', mobile: true }
      }
      columns.contact = { label: 'Contact', mobile: true }
      columns.contact_phone = { label: 'Téléphone Contact', mobile: true }
      columns.contact_address = { label: 'Ville Contact', mobile: true }
      columns.contact_email = { label: 'Email Contact', mobile: true }
      columns.created_on = { label: 'Date de création', mobile: true }
      return columns
    }
  },
  watch: {

    // bigExport (to) {
    //   if (to) {
    //     const documentName = 'Liste des dénonciations'
    //     const service = this.service
    //     this.sendBigExport(documentName, service, this.claimsForExport)
    //   }
    // }
  },
  created () {
    if ((this.$route.query && Object.keys(this.$route.query).length !== 0) || this.$route.params.filter) {
      // Clean les filters pour les doublons
      if (this.$route.params.resetFiltersForDoublon) {
        this.filters = cloneDeep(this.initFilters)
      }
      if (this.$route.params.filter) {
        this.filters['pk'] = this.$route.params.filter
        this.filters['status'] = this.$route.params.status
      }
      this.initQueryFilters()
      this.loadOnCreate = false
      this.query = { ...this.query, ...this.$route.query }
      if ('status' in this.$route.query) {
        this.filters.status = this.$route.query.status
      }
      if (!this.$route.params.resetFiltersForDoublon) {
        this.loadItems()
      }
    } else if ('claimList' in this.savedFilters) {
      this.loadOnCreate = false
      this.initSavedFilters()
    }
    this.getPrograms()
    if (this.isPromoteur) {
      this.getAccounts()
    } else {
      this.getPromoteurs()
    }
    this.getUsers()
    this.getContacts()
    this.cancelSelect()
  },
  methods: {
    initSavedFilters () {
      this.filters = cloneDeep(this.savedFilters.claimList)
      this.updateSimpleFilter()
    },
    // isPromoteurDetailsActivated (option) {
    //   return this.storeAccounts.find(a => a.name === option.promoteur.name).promoteur_details_activated
    // },
    async getDoublon (denunciation) {
      if (denunciation && denunciation.duplicates.length > 0) {
        let claimListPk = []
        let claimList = []
        for (let i of denunciation.duplicates) {
          let params = {
            status: ['approved', 'pending'],
            contact: i
          }
          let { data } = await this.$api.get(this.$resources.CLAIM, params)
          data.items.forEach(claim => {
            if (!claimListPk.includes(claim.pk)) {
              claimListPk.push(claim.pk)
              claimList.push(claim)
            }
          })
        }
        claimListPk.push(denunciation.pk)
        claimList.push(denunciation)
        this.items = claimList
        this.filters['pk'] = claimListPk
        this.filters['status'] = ['approved', 'pending']
        // this.initQueryFilters()
        // this.loadOnCreate = false
        // this.$router.replace({ name: 'DenunciationList', params: { filter: claimListPk } })
      }
    },
    async getDoublonContact (denunciation) {
      if (denunciation && denunciation.all_pk_contact.length > 0) {
        denunciation.all_pk_contact.push(denunciation.contact.pk)
        this.$router.push({ name: 'ContactList', params: { filter: denunciation.all_pk_contact, resetFiltersForDoublon: true } })
      }
    },
    /**
      * Confirm modal
      */
    confirmDelete () {
      return this.$swal({
        title: 'Suppression dénonciation',
        text: 'La suppression de la dénonciation ne vous permettra plus de vérifier les doublons de ce contact sur ce programme.',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
          // cancelButton: 'button is-primary'
        }
      })
    },
    /**
      * get accounts list
      * @param {number} query - searchable_name
      */
    async getAccounts (query) {
      let params = {
        searchable_name: query,
        per_page: 100
      }
      try {
        let { data } = await this.$api.get(this.$resources.ACCOUNT, params)
        this.accounts = data.items
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * update claim status
      * @param {string} id - id of claim
      * @param {string} value - status
      */
    async updateStatus (id, value) {
      const params = {
        status: value
      }
      try {
        let { data } = await this.$api.patch(this.$resources.CLAIM, id, params)
        if (params.status === 'refused') {
          this.$toasted.global.success('Dénonciation refusée')
        } else {
          this.$toasted.global.success('Dénonciation acceptée')
        }
        this.$store.commit('updateRunningDenunciation', { denunciation: data })
        this.loadDocuments()
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * get contacts list
      * @param {number} query - searchable_name
      */
    async getContacts (query) {
      let params = {
        searchable_name: query
      }
      try {
        let { data } = await this.$api.get(this.$resources.CONTACT, params)
        this.contacts = data.items
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * get users list
      * @param {number} query - searchable_name
      */
    async getUsers (query) {
      try {
        const { data } = await this.$api.get(this.$resources.USER, { searchable_name: query })
        this.users = data.items
      } catch (e) {
        console.log(e)
      }
    },
    /**
      * get promoteurs list
      * @param {number} query - searchable_name
      */
    async getPromoteurs (query) {
      let params = {
        status: 'accepted',
        searchable_name: query
      }
      let request = await this.$api.get(this.$resources.ACCOUNT_RELATION, params)
      this.promoteurs = request.data.items.map(x => x.account_one)
    },
    /**
      * get programs list
      * @param {number} query - searchable_name
      */
    async getPrograms (query) {
      let params = {
        sort: 'name:asc',
        searchable_name: query
      }
      try {
        let request = await this.$api.get(this.$resources.PROGRAM, params)
        this.programs = request.data.items
      } catch (err) {
        console.log(err)
      }
    },
    /**
       * function to use before load items
       * prepare query
       * loadItems in GenericListMixin.js
       */
    beforeGet () {
      if (this.query.contact) {
        this.query.contact = this.query.contact.pk
      }
      // if (this.query.program) {
      //   this.query.program = this.query.program.pk
      // }
      if (this.query.promoteur) {
        this.query.promoteur = this.query.promoteur.pk
      }
      if (this.query.account) {
        this.query.account = this.query.account.pk
      }
      if (this.query.user) {
        this.query.user = this.query.user.pk
      }
      if (this.query.user__account) {
        this.query.user__account = this.query.user__account.pk
      }
      for (let key in this.filters) {
        this.$store.commit('setSavedFilters', { from: 'claimList', name: key, value: this.filters[key] })
      }
    },
    /**
       * Change route
       */
    goToRoute (link) {
      this.$router.push({ name: link })
    },
    async duplicateRisk (riskLevel, contact) {
      let contactDoublon
      if (this.savedFilters.claimList && this.savedFilters.claimList.status.length <= 0) {
        this.savedFilters.claimList.status.push('pending', 'approved')
        await this.loadItems()
        if (riskLevel === 1) {
          contactDoublon = this.items.filter(x => x.contact.first_name === contact.first_name)
        }
        if (riskLevel === 2) {
          contactDoublon = this.items.filter(x => x.contact.last_name === contact.last_name)
        }
        if (riskLevel === 3) {
          contactDoublon = this.items.filter(x => x.contact.email.toLowerCase() === contact.email.toLowerCase())
        }
        this.items = contactDoublon
      } else {
        this.initSavedFilters()
        let itemsDoublonExist = this.items.findIndex(x => x.duplicate_risk === 0)
        if (itemsDoublonExist === -1 || itemsDoublonExist === 1) {
          await this.loadItems()
        }
      }
    },
    async showDuplicates (denunciation, contact) {
      this.savedFilters.claimList.status.pop()
      let risk = denunciation.duplicate_risk
      if (risk === 1) {
        this.duplicateRisk(risk, contact)
      } else if (risk === 2) {
        this.duplicateRisk(risk, contact)
      } else if (risk === 3) {
        this.duplicateRisk(risk, contact)
      }
    },
    initQueryFilters () {
      let routeQuery = {}
      for (let key in this.$route.query) {
        if (key === 'user' && this.$route.query[key] === 'isnull') {
          this.filters[key] = this.$route.query[key]
        } else if (Array.isArray(this.filters[key])) {
          this.filters[key].push(this.$route.query[key])
        } else {
          this.filters[key] = this.$route.query[key]
        }
        routeQuery[key] = this.$route.query[key].pk
      }
      this.query = { ...this.query, ...routeQuery }
      this.updateSimpleFilter()
    },
    // async ExportAllClaims () {
    //   let params = {
    //     type: 'export',
    //     status: this.filters.status
    //   }
    //   this.denunLoading = true
    //   try {
    //     const { data } = await this.$api.get(this.$resources.CLAIM, params)
    //     for (let claim of data.items) {
    //       this.claimsForExport.push(claim.pk)
    //     }
    //     if (this.claimsForExport.length < 150) {
    //       this.$store.commit('setSelectedItems', this.claimsForExport)
    //       this.exportXlsFromMultiselect('CLAIM', 'liste-denonciations')
    //     } else {
    //       this.bigExport = true
    //       this.$toasted.global.success('Vous allez recevoir vos fichiers par mail')
    //     }
    //     this.denunLoading = false
    //   } catch (e) {
    //     console.log(e)
    //     this.denunLoading = false
    //     this.$toasted.global.danger('Erreur lors de l\'envoie des advs')
    //   }
    // }
    cancelSelect () {
      this.parentActionGroup = false
      this.$store.commit('cancelMultiselection')
    },
    handleActionGroupUpdate (newValue) {
      this.parentActionGroup = newValue
    }
  }
}
</script>

<style lang="sass">

.container-btn-export-denon
  width: 217px
  flex: 0 0 auto

.btn_export_denon
  background-color: #fff
  color: #7a7a7a
  width: 100%
  min-height: 100%
  font-size: 1.2rem
  display: flex
  align-items: center
  justify-content: center

.container_select_multiple_denon
  width: 100%

.select_multiple_denon
  text-decoration: none !important
  padding: 13px
  width: 100%
  color: white

.select_multiple_denon:hover
  color: white
  text-decoration: none
</style>
